<template>
  <MaterialCard
    color="green"
    full-width
    :style="`position: sticky; top: ${offsetTop}px; z-index: 10;`"
  >
    <slot name="top" />
    <v-tabs
      grow
    >
      <v-tab
        ripple
      >
        顧客
      </v-tab>
      <v-tab
        ripple
      >
        タンク
      </v-tab>
      <v-tab ripple>
        センサー
      </v-tab>
      <CustomerMenu
        v-if="isManager(user.roleId)"
        :customer="selected"
      />
      <v-tab-item>
        <CustomerTab
          :selected="selected"
          @reset="$emit('reset', $event)"
        />
      </v-tab-item>
      <v-tab-item>
        <LoaderContainer v-if="loadingTab" />
        <TankTab
          v-show="!loadingTab"
          :tanks="tanks"
          :selected="selectedTank"
          :customer-id="selected ? selected.id : null"
          :tank-selection="tankSelection"
          @change-tank="selectTank"
          @remove-new-tank="removeNewTank"
          @update-sensor-info="updateSensorInfo"
          @reset="$emit('reset', $event)"
        />
      </v-tab-item>
      <v-tab-item>
        <LoaderContainer v-if="loadingTab" />
        <SensorTab
          v-show="!loadingTab"
          :customer="selected"
          :tank="selectedTank"
          :tank-selection="tankSelection"
          :records="records"
          @change-tank="selectTank"
        />
      </v-tab-item>
    </v-tabs>
  </MaterialCard>
</template>
<script>
import { mapState } from 'vuex'
import { CustomerTab, TankTab, SensorTab } from './CustomerDetail/Tabs'
import { LoaderContainer, CustomerMenu } from './CustomerDetail/index'
import { api } from '@/api.js'
import { isManager } from '@/utils/helpers.js'

export default {
  components: {
    CustomerTab,
    TankTab,
    SensorTab,
    LoaderContainer,
    CustomerMenu
  },
  props: {
    selected: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      tanks: [],
      records: [],
      sensor: {},
      selectedTank: {},
      loadingTab: false,
      newTankDefault: () => ({
        id: 'new',
        tankType: 0,
        volumeThreshold: null,
        consumptionRate: null,
        serialNo: '',
        deliveryFrequency: null,
        volumeUpdatedAt: null
      })
    }
  },
  computed: {
    ...mapState('display', ['offsetTop']),
    ...mapState('app', ['user']),
    tankSelection () {
      return this.tanks.map(({ id }) => {
        return {
          value: id,
          text: id
        }
      })
    }
  },
  watch: {
    selected (val) {
      this.selectTank()
    }
  },
  mounted () {
    this.selectTank()
  },
  methods: {
    isManager,
    async selectTank (id) {
      if (id === 'new') {
        this.tanks.push(this.newTankDefault())
        this.selectedTank = this.tanks[this.tanks.length - 1]
        return
      }

      this.loadingTab = true
      this.tanks = [...this.selected.tanks]
      // idを指定せずcallした時は先頭のタンクを選択
      const selectedTank = id
        ? this.tanks.find(t => t.id === id)
        : this.tanks[0]

      try {
        const { record, sensor } = await api.getCustomerTank(this.selected.id, selectedTank.id)
        this.records = record.records
        if (sensor) {
          selectedTank.sensorId = sensor.id
        }
      } catch (err) {
        this.records = []
      } finally {
        this.loadingTab = false
        this.selectedTank = selectedTank
      }
    },
    updateSensorInfo ({ id, serialNo }) {
      this.selectedTank = { ...this.selectedTank, sensorId: id, serialNo: serialNo }
    },
    removeNewTank () {
      this.tanks.pop()
      if (this.selectedTank.id === 'new') {
        this.selectedTank = this.tanks[0]
      }
    }
  }
}
</script>
